import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "smilingFace"
const SmilingFaceIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M7.113 12.42C7.498 13.4 8.17 14.24 9.037 14.835 9.907 15.428 10.934 15.747 11.987 15.75 13.037 15.753 14.066 15.439 14.938 14.85 15.811 14.26 16.486 13.423 16.877 12.445L18.27 13.001C17.768 14.258 16.9 15.335 15.78 16.093 14.657 16.85 13.334 17.253 11.981 17.25 10.63 17.246 9.308 16.836 8.192 16.073 7.073 15.309 6.211 14.228 5.716 12.968zM8.261 8.25C8.807 8.253 9.333 8.454 9.741 8.815 10.15 9.177 10.414 9.675 10.482 10.217L8.994 10.405C8.971 10.226 8.884 10.06 8.747 9.939 8.611 9.818 8.436 9.751 8.254 9.75 8.072 9.75 7.895 9.815 7.758 9.934 7.62 10.054 7.53 10.219 7.507 10.399L6.764 10.297 6.02 10.196C6.094 9.656 6.362 9.159 6.774 8.802 7.186 8.444 7.715 8.247 8.261 8.25M15.761 8.25C16.307 8.253 16.833 8.454 17.241 8.815 17.65 9.177 17.914 9.675 17.982 10.217L16.494 10.405C16.471 10.226 16.384 10.06 16.247 9.939 16.111 9.818 15.936 9.751 15.754 9.75 15.572 9.75 15.395 9.815 15.258 9.934 15.12 10.054 15.03 10.219 15.007 10.399L14.264 10.297 13.52 10.196C13.594 9.656 13.862 9.159 14.274 8.802 14.686 8.444 15.215 8.247 15.761 8.25" />
          <path
            fillRule="evenodd"
            d="M12 1.5C17.799 1.5 22.5 6.201 22.5 12S17.799 22.5 12 22.5 1.5 17.799 1.5 12 6.201 1.5 12 1.5M12 3C7.03 3 3 7.03 3 12S7.03 21 12 21 21 16.97 21 12 16.97 3 12 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default SmilingFaceIcon
